import React from 'react'
import { useNavigate } from 'react-router-dom'
import Calendar from './Calendar'
import { Loading } from '../styles'
import { DailyView } from './styles'
import { useDayData, realtimeProps } from './hooks/useDayData'
import RTDailyCalendar from '@/v2/hooks/subscriptions/messages/RTDailyCalendar'

const Day = props => {
  const navigate = useNavigate()
  const {
    date,
    view: calendarView = 'day',
    subjectView,
    typeFilter,
    selectedColumn,
    isMobile,
    defaultStartHour,
    defaultEndHour,
    loading: loadingData,
    error: errorData,
    appointments,
    timeOffs,
    clinicHours,
  } = props

  const {
    columns,
    events,
    offHours,
    loading: loadingDay,
    error: errorDay,
  } = useDayData({
    date,
    subjectView,
    typeFilter,
    selectedColumn,
    isMobile,
    appointments,
    timeOffs,
    clinicHours,
  })

  const loading = loadingData || loadingDay
  const error = errorData || errorDay

  if (loading) {
    return (
      <Loading>
        <p>Loading...</p>
      </Loading>
    )
  }
  if (error) {
    navigate('/500')
    return null
  }

  return (
    <DailyView className="daily-view">
      <RTDailyCalendar {...realtimeProps(date)} />
      <Calendar
        key={`${subjectView}-${date}-${selectedColumn || 'all'}`}
        view={calendarView}
        subjectView={subjectView}
        columns={columns}
        events={events}
        date={date}
        startHour={defaultStartHour}
        endHour={defaultEndHour}
        offHours={offHours}
      />
    </DailyView>
  )
}

export default Day
